import React from "react";
import { Container, Heading } from "theme-ui";
import ArticleDate from "./articleDate";

const ArticleHero = ({
  title,
  publishedAt,
  updatedAt,
  i18nPublishedAt,
  i18nUpdatedAt,
}) => (
  <Container variant="blog">
    <Heading variant="display" as="h1" css={{ textAlign: "center" }} sx={{ mb: 3 }}>
      {title}
    </Heading>
    <ArticleDate
      publishedAt={publishedAt}
      updatedAt={updatedAt}
      i18nPublishedAt={i18nPublishedAt}
      i18nUpdatedAt={i18nUpdatedAt}
    />
  </Container>
);

export default ArticleHero;
